module.exports = __webpack_public_path__ + "static/img/alesong_logo.867480f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alesong_logo.png
// module id = 288
// module chunks = 1